import React from 'react';
import { Site } from '../../lib/Site';
import FooterLinksItem from '../FooterLinksMenu/FooterLinksItem';

interface Props {
    site: Site;
    reduced?: boolean;
}

export default function DesignServicesMenu({ reduced = false }: Props) {
    return (
        <div className="footer-links-menu">
            <ul className="footer-links-menu__items">
                <FooterLinksItem label={__('Design contests')} url="/contests" />
                <FooterLinksItem label={__('1-to-1 Projects')} url="/projects" />
                <FooterLinksItem label={__('Find a designer')} url="/designers/search" />
                <FooterLinksItem label={__('Discover inspiration')} url="/discover" />
                {!reduced && <FooterLinksItem label={__('Pricing')} url="/pricing" />}
                <FooterLinksItem label="99designs Studio" url="/pro/studio" />
                <FooterLinksItem label="99designs Pro" url="/pro" />
            </ul>
        </div>
    );
}
